import { Divider, Menu, MenuItem } from "@mui/material";
import { ReactComponent as ArrowDownSvg } from "../../assets/ArrowDown.svg"
import { ReactComponent as AddNewSvg } from "../../assets/AddNew.svg"
import DndSvg from "../../assets/dnd_placeholder.png";
import DragOverSvg from "../../assets/DragOver.svg";
import { useState } from "react";
import { getNotificationTypee } from "../../types";
import { Link } from "react-router-dom";

function DropPlaceHolder({ isOver, key, unassignedNotification, handleClickFromUnassignedMenuList, colId }) {

  const [anchorEl, setAnchorEl] = useState(null); // to show list of unassignes notifications 
  const open = Boolean(anchorEl);


  const handlePlaceHolderClick = (event) => {
    setAnchorEl(event.currentTarget); // open menu at the clicked element
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <div className="dndn_planner_placeholder" style={{ background: isOver ? "#d4d8d9" : "#f4f4f4", border : isOver ? "1px solid #38748d" : "1px solid rgba(33, 33, 33, 0.2)"}} key={key}>
      <div>
        <img src={isOver ? DragOverSvg : DndSvg} />
      </div>
      <div className="_content">
        <>
          {
            isOver ? "Fallen lassen, um Meldung zuzuordnen" :
              <>Meldungen hierher ziehen oder <div style={{ display: unassignedNotification?.length ? "flex" : "none" , pointerEvents: unassignedNotification?.length ? "all" : "none" }} onClick={handlePlaceHolderClick}>zuweisen <ArrowDownSvg /></div></>

          }
        </>
      </div>
      {
        unassignedNotification?.length && open ?
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose} className="unassignedMenuList">

            <div style={{ maxHeight: "200px", overflowY: "auto" }}>

              {unassignedNotification.map((notification, index) => {
                return (
                  <MenuItem onClick={() => { handleClose(); handleClickFromUnassignedMenuList(notification.nodeid, colId,""); }} className="_menuItem">
                    <div>
                      <div className="_title">{notification.title}</div>
                      <div className="_desc"> {getNotificationTypee(
                        notification?.type,
                        "de"
                      )}</div>
                    </div>

                  </MenuItem>
                )
              })}
            </div>

            <Divider sx={{ height: "2px" }} orientation="horizontal" />
            <Link
              to={"/create-notification"}
              style={{ color: "black" }}
              state={{
                notification: "",
                equip: "",
                equip_pool: "",
                date: "",
                time: "",
                pageType: "create",
                from: "aufgabe"
              }}
            >
              <div className="_addNewNotification">
                <AddNewSvg /> <span>
                  neue Meldung erstellen
                </span>
              </div>
            </Link>
          </Menu>
          : ""}

    </div>
  );
}

export default DropPlaceHolder;
